import dayjs from 'dayjs';
import i18next from 'i18next';

import { BorderedCell } from '../pdfMakeUtils';
import { TicketData } from './getPdfTemplate';

const getTemplateTable = (ticketData: TicketData) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const incidentOrderInfoTable = {
    table: {
      widths: ['*', '*', '*'],
      body: [
        [
          {
            text: `${i18next.t('ticket.pdf.information', {
              ns: 'global'
            })}`,
            style: 'titleBold',
            colSpan: 3
          },
          '',
          ''
        ],
        [
          BorderedCell(
            `${i18next.t('common.commonProperties.client', {
              ns: 'global'
            })}:\n${
              ticketData?.clientActive?.name ||
              i18next.t('ticket.pdf.noData', {
                ns: 'global'
              })
            }`
          ),
          BorderedCell(
            `${i18next.t('common.commonProperties.municipality', {
              ns: 'global'
            })}:\n${
              ticketData?.location?.municipalityName ||
              i18next.t('ticket.pdf.noData', {
                ns: 'global'
              })
            }`
          ),
          BorderedCell(
            `${i18next.t('ubications.map.direction', {
              ns: 'global'
            })}:\n${
              ticketData?.location?.addressFull ||
              i18next.t('ticket.pdf.noData', {
                ns: 'global'
              })
            }`
          )
        ],
        [
          BorderedCell(
            `${i18next.t('common.commonProperties.requestedBy', {
              ns: 'global'
            })}:\n${
              ticketData?.dataIncident?.requestedByUser ||
              i18next.t('ticket.pdf.noData', {
                ns: 'global'
              })
            }`,
            null,
            3
          )
        ],
        [
          BorderedCell(
            `${i18next.t('common.commonProperties.ubication', {
              ns: 'global'
            })}:\n${
              ticketData?.location?.name ||
              i18next.t('ticket.pdf.noData', {
                ns: 'global'
              })
            }`
          ),
          BorderedCell(
            `${i18next.t('common.commonProperties.tradeName', {
              ns: 'global'
            })}:\n${
              ticketData?.location?.description ||
              i18next.t('ticket.pdf.noData', {
                ns: 'global'
              })
            }`,
            null,
            2
          ),
          ''
        ],
        [
          {
            table: {
              widths: ['*', '*'],
              body: [
                [
                  BorderedCell(
                    `${i18next.t('common.commonProperties.latitude', {
                      ns: 'global'
                    })}:\n${
                      ticketData?.location?.latitude ||
                      i18next.t('ticket.pdf.noData', {
                        ns: 'global'
                      })
                    }`
                  ),
                  BorderedCell(
                    `${i18next.t('common.commonProperties.longitude', {
                      ns: 'global'
                    })}:\n${
                      ticketData?.location?.longitude ||
                      i18next.t('ticket.pdf.noData', {
                        ns: 'global'
                      })
                    }`
                  )
                ]
              ],
              heights: 'auto'
            },
            heights: '100%',
            layout: 'noBorders',
            colSpan: 3,
            margin: [0, 0]
          },
          '',
          ''
        ],
        ticketData?.dataIncident?.ticketClientNumber
          ? [
              BorderedCell(
                `${i18next.t('common.commonProperties.postalCode', {
                  ns: 'global'
                })}:\n${
                  ticketData?.location?.postalCode ||
                  i18next.t('ticket.pdf.noData', {
                    ns: 'global'
                  })
                }`
              ),
              BorderedCell(
                `${i18next.t('clients.stage', {
                  ns: 'global'
                })}:\n${
                  ticketData.dataIncident?.ticketStatusName ||
                  i18next.t('ticket.pdf.noData', {
                    ns: 'global'
                  })
                }`
              ), // "Etapa" aplica solo para las Ubicaciones en Colombia por ende se queda el campo vacio
              BorderedCell(
                `${i18next.t('ticket.pdf.incidentAndRequirement', {
                  ns: 'global'
                })}:\n${ticketData?.dataIncident?.ticketClientNumber}`
              )
            ]
          : [
              {
                table: {
                  widths: ['*', '*'],
                  body: [
                    [
                      BorderedCell(
                        `${i18next.t('common.commonProperties.postalCode', {
                          ns: 'global'
                        })}:\n${
                          ticketData?.location?.postalCode ||
                          i18next.t('ticket.pdf.noData', {
                            ns: 'global'
                          })
                        }`
                      ),
                      BorderedCell(
                        `${i18next.t('clients.stage', {
                          ns: 'global'
                        })}:\n${
                          ticketData.dataIncident?.ticketStatusName ||
                          i18next.t('ticket.pdf.noData', {
                            ns: 'global'
                          })
                        }`
                      )
                    ]
                  ],
                  heights: 'auto'
                },
                heights: '100%',
                layout: 'noBorders',
                colSpan: 3,
                margin: [0, 0]
              },
              '',
              ''
            ],
        [
          {
            table: {
              widths: ['*', '*'],
              body: [
                [
                  BorderedCell(
                    `${i18next.t('ticket.pdf.reportDate', {
                      ns: 'global'
                    })}:\n${dayjs()
                      .local()
                      .tz(userTimeZone)
                      .format('DD/MM/YYYY HH:mm:ss ')}`
                  ),
                  BorderedCell(
                    `${i18next.t('common.commonMessages.createdDate', {
                      ns: 'global'
                    })}:\n${
                      ticketData?.dataIncident?.ticketCreationDateUTC
                        ? dayjs(ticketData?.dataIncident?.ticketCreationDateUTC)
                            .tz(userTimeZone)
                            .local()
                            .format('DD/MM/YYYY HH:mm:ss')
                        : i18next.t('ticket.pdf.noData', {
                            ns: 'global'
                          })
                    }`
                  )
                ]
              ],
              heights: 'auto'
            },
            heights: '100%',
            layout: 'noBorders',
            colSpan: 3,
            margin: [0, 0]
          },
          '',
          ''
        ]
      ]
    },
    layout: 'tableBorderedContainer'
  };

  return incidentOrderInfoTable;
};

export default getTemplateTable;
